const makeClassName = (className:string|undefined, newClasses:string[]) : string =>
    [className, ...newClasses].filter(f=>!!f).join(" ")

export {makeClassName};